import React, { useEffect } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Quest } from "../../../lib/types";
import HelpIcon from "../../Common/HelpIcon";
import { questListViewed } from "../../../store/actions";

const mapStateToProps = (state: any) => ({
  availableQuests: state.governorate.availableQuests,
  finishedQuests: state.governorate.finishedQuests,
  tutorialFinished: state.governorate.tutorialFinished
});

const mapDispatchToProps = (dispatch: any) => ({
  questListViewedDispatch: () => dispatch(questListViewed())
})

const connector = connect(mapStateToProps, mapDispatchToProps);

const QuestList = ({
  availableQuests,
  finishedQuests,
  tutorialFinished,
  questListViewedDispatch
}:ConnectedProps<typeof connector>) => {
  useEffect(() => {
    questListViewedDispatch();
  }, [])

  return (
    <>
      <h3 className="title">Tutorial - Quests</h3>
      {!!tutorialFinished && <p className={"text-info text-bigger"}>Tutorial is successfully finished</p>}
      <div className="links">
        {availableQuests && availableQuests
          .map((quest: Quest) => <div className="row">
            <div className={`${quest.parts === 0 ? "col-xs-offset-1 col-md-7" : "col-xs-8"} no-wrap`}>
              {quest.name}
            </div>
            <div className="col-xs-2 no-wrap">
              <HelpIcon
                title={quest.name}
                content={`<p>${quest.description}</p><p>Objective: ${quest.objective}</p>${quest.reward ? `<p>Reward: ${quest.reward}</p>` : ""}`}
                iconClasses={["white", "align-sub"]}
              />
            </div>
            <div className="col-xs-1">
              <i className={`icon icon-sm icon-zaskrtnuto middle ${quest.finished ? "positive" : "blank"}`}/>
            </div>
          </div>)
        }

        {finishedQuests && finishedQuests
          .map((quest: Quest) => <div className="row">
            <div className={`${quest.parts === 0 ? "col-xs-offset-1 col-xs-7" : "col-xs-8"} no-wrap`}>
              {quest.name}
            </div>
            <div className="col-xs-2 no-wrap">
              <HelpIcon
                title={quest.name}
                content={`<p>${quest.description}</p><p>Objective: ${quest.objective}</p>${quest.reward ? `<p>Reward: ${quest.reward}</p>` : ""}`}
                iconClasses={["white", "align-sub"]}
              />
            </div>
            <div className="col-xs-1">
              <i className={`icon icon-sm icon-zaskrtnuto middle ${quest.newFinished ? "positive" : ""}`}/>
            </div>
          </div>)
        }
      </div>
    </>
  )
}

export default connector(QuestList);
